import { Injectable, Output, EventEmitter} from '@angular/core';
import { HttpClient,HttpRequest,HttpHeaders,HttpEventType } from '@angular/common/http';
import { BehaviorSubject} from 'rxjs';
import { map, tap ,last} from 'rxjs/operators';
import { NotificationMessageComponent } from '../notification-message/notification-message.component';
import { MatSnackBar } from '@angular/material';


@Injectable({
  providedIn: 'root'
}) 
export class UploadFilesService {
  name = new BehaviorSubject(0);
  @Output() headerPlanUpdate: EventEmitter<any> = new EventEmitter<any>();
  getName = this.name.asObservable();
  authenticationService:any;
  PublicURL:any

  constructor(private http: HttpClient, private snackBar:MatSnackBar) {

  }

  private _stepValue: number;

      get getStepValue(): number {
          return this._stepValue;
      }

      set setStepValue(value:number){
        this._stepValue = value;
      }

  // uploadFilesFromDropbox(docs){
  //   return this.http.post<any>(this._PublicURL+'/Api_convert/uploadFilesFromDropbox',{docs:docs})
  //     .pipe(map(data => {
  //       console.log("data === service === ",data);
  //       return data;
  //     }))
  // }

  // uploadFilesFromGoogleDrive(access_token,docs){
  //   return this.http.post<any>(this._PublicURL+'/Api_convert/uploadFilesFromGoogleDrive',{access_token:access_token,docs:docs})
  //     .pipe(map(data => {
  //       console.log("data === service === ",data);
  //       return data;
  //     }))
  // }

  uploadFiles(filesToUpload,moduleName,mapid,uploadFileType,referenceLayer=false) {
    let formData:FormData = new FormData();
    let headers = new HttpHeaders();
    let raster_on = "1"
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    if(this.authenticationService.currentUserValue){
      headers.append('Authorization',this.authenticationService.currentUserValue.token);
    }
    let Option = { headers: headers };
    console.log("option",Option);
    for(let i=0; i < filesToUpload.length; i++)
    {
      formData.append('uploadFile[]', filesToUpload[i]);
    }
    let req : any="";
    if(moduleName=='CONVERTER'){
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython +'/Api_convert/uploadFile', formData, { reportProgress: true})
    }
    else if(moduleName=='ANALYSIS' && uploadFileType=='Excel_Csv'){
      formData.append('mapid',mapid);
      formData.append('raster_on',raster_on)
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython +'/Api_map_analysis/uploadCSVFile', formData, { reportProgress: true})
    }
    else if(moduleName=='STOREMAPPER' && uploadFileType=='Excel_Csv'){
//@Ritivesh Commented
      formData.append('mapid',mapid);
      formData.append('raster_on',raster_on)
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython+'/Api_map_analysis/importTemplate', formData, { reportProgress: true})
    }
    else if(moduleName=='Geocoder' && uploadFileType=='Excel_Csv'){
      formData.append('mapid',mapid);
      formData.append('raster_on',raster_on)
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython+'/Api_map_analysis/importTemplate', formData, { reportProgress: true})
      //req = new HttpRequest('POST',this._PublicURL +'/Api_map_analysis/importTemplate', formData, { reportProgress: true})
    }
    else if(moduleName=='ANALYSIS' && uploadFileType === "vector" ){
      formData.append('mapid',mapid);
      formData.append('raster_on',raster_on)
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython +'/Api_map_analysis/uploadFile', formData, { reportProgress: true})
    }
    else if(moduleName=='ANALYSIS_IMPORT' && uploadFileType=='Excel_Csv'){
      formData.append('layerid',mapid);
      formData.append('raster_on',raster_on)
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython+'/Api_map_analysis/importTemplate', formData, { reportProgress: true})
    }
    
    else if (moduleName === "TerritoryModulePoint" && uploadFileType === "Excel_Csv"  ){
      formData.append('mapid',mapid);
      formData.append('raster_on','0')
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython +'/Api_map_analysis/uploadCSVFile', formData, { reportProgress: true})
    }

    else if (moduleName === "TerritoryPointToPolygon" && uploadFileType === "Excel_Csv"  ){
      formData.append('mapid',mapid);
      formData.append('raster_on','0')
      formData.append('added_from','REFERENCE_TERRITORY')
      
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython +'/Api_map_analysis/uploadCSVFile', formData, { reportProgress: true})
    }

    else if (moduleName === "TerritoryPointToPolygon" && uploadFileType === "vector"  ){
      formData.append('mapid',mapid);
      formData.append('raster_on','0')
      formData.append('added_from','REFERENCE_TERRITORY')
      
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython +'/Api_map_analysis/uploadFile', formData, { reportProgress: true})
    }

    else if (moduleName === "TerritoryModule" && uploadFileType === "vector"  ){
      formData.append('mapid',mapid);
      formData.append('raster_on','1')
      if(referenceLayer){
        formData.append('added_from','REFERENCE_TERRITORY')
      }
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython +'/Api_map_analysis/uploadFile', formData, { reportProgress: true})
    }

    else{
      formData.append('mapid',mapid);
      formData.append('raster_on',raster_on)
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython+'/Api_map_analysis/uploadRasterFile', formData, { reportProgress: true})
    }

    return this.http.request(req).pipe(
          map(event => {         
                switch (event.type) {
                      case HttpEventType.UploadProgress:
                            // this.subject.next(Math.round(event.loaded * 100 / event.total));
                            console.log(Math.round(event.loaded * 100 / event.total));
                            this.name.next(Math.round(event.loaded * 100 / event.total));
                            // this.bSubject.next(Math.round(event.loaded * 100 / event.total));
                            break;
                      case HttpEventType.Response:
                              if(event.status==200){
                                this.headerPlanUpdate.emit(true)
                              } 
                            return event;
                }
          }),
          tap(message => { }),
       last()
      //  catchError((error: HttpErrorResponse) => {
      //        // file.inProgress = false;
      //        // file.canRetry = true;
      //        return of(` upload failed.`);
      //  })
    )
  }
  getHeaderEmitter(){
    return this.headerPlanUpdate;
  }



  UploadTerritoryFiles(filesToUpload,moduleName,mapid,layerid,uploadFileType,option="") {
    let formData:FormData = new FormData();
    let headers = new HttpHeaders();
    let raster_on = "0"
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    if(this.authenticationService.currentUserValue){
      headers.append('Authorization',this.authenticationService.currentUserValue.token);
    }
    let Option = { headers: headers };
    console.log("option",Option);
    for(let i=0; i < filesToUpload.length; i++){
      formData.append('uploadFile[]', filesToUpload[i]);
    }
    let req : any="";

    if(moduleName == "TerritoryModule"){
      formData.append('mapid',mapid);
      formData.append('raster_on',raster_on)
      formData.append('layerid',layerid)
      formData.append('option',option)
      req = new HttpRequest('POST',this.PublicURL.PublicURLPython+'/Api_map_analysis/importTemplateForAddingUsersLayer', formData, { reportProgress: true})
    }


    return this.http.request(req).pipe(
          map((event:any) => {         
                switch (event.type) {
                      case HttpEventType.UploadProgress:
                            // this.subject.next(Math.round(event.loaded * 100 / event.total));
                            console.log(Math.round(event.loaded * 100 / event.total));
                            this.name.next(Math.round(event.loaded * 100 / event.total));
                            // this.bSubject.next(Math.round(event.loaded * 100 / event.total));
                            break;
                      case HttpEventType.Response:
                              if(event.status== 200){
                                this.headerPlanUpdate.emit(true)
                              }
                            return event;
                }
          }),
          tap(message => { }),
       last()
      //  catchError((error: HttpErrorResponse) => {
      //        // file.inProgress = false;
      //        // file.canRetry = true;
      //        return of(` upload failed.`);
      //  })
    )
  }

  openSnackBar(message: string, panelClass: string, type: string) {
    var msgDuration = type === "success" ? 2000 : null;
    this.snackBar.openFromComponent(NotificationMessageComponent, {
      data: message,
      panelClass: panelClass, //snackbar-success ||snackbar-error
      duration: msgDuration,
      verticalPosition: "top", // Allowed values are  'top' | 'bottom'
      horizontalPosition: "right",
    });
  }


  // getAnalysisUploadLayerQuestion(){
  //   return {
  //       1 : {
  //         name : "Do you have data to upload on Map?",
  //         children : [
  //           {
  //             id : 2,
  //             name : "yes",
  //           },
  //           {
  //             id : 3,
  //             name : "No",
  //           }
  //         ]
  //       },
        // 2 : {
        //   name : "What kind of data do you have?",
        //   children: [
        //     {
        //       id: "UploadFile",
        //       name : "GIS Data",
        //     },
        //     {
        //       id : 4,
        //       name : "Excel/CSV file"
        //     }
        //   ]
        // },
        // 4 : {
        //   name : "Which Excel/CSV data format?",
        //   children : [
        //     {
        //       id : "UploadExcelwithLatLon",
        //       name : "have Lat lon values or WKT?"
        //     },
        //     {
        //       id : "UploadExcelWithTextAddress",
        //       name : "have proper location text address i.e city, state, stree name etc"
        //     },
        //     {
        //       id : "UploadExcelWithArea",
        //       name : "representation is a group of Area example a Territory Data or a polygon level data"
        //     }
        //   ]
        // },
        // 3 : {
        //   name : "Dont worry, you can either do any of the following activities",
        //   children : [
        //     {
        //       id : "CreatePointLinePolygon",
        //       name : "Create layer from scratch - point, line and polygon layer"
        //     },
        //     {
        //       name : "Add GIS Data - From existing files",
        //       id : "GISData"
        //     }
        //   ]
        // }
      // }
  // }
}
